// 匹配span标签 []
export const spans = html => html.match(/<span (.*?)>(.*?)<\/span>/g)
// 匹配span标签内容 string
export const spanText = span => span.match(/<span[^>]*>([\s\S]*?)<\/span>/)[1]
// 匹配p标签 []
export const p = html => html.match(/<p>(.*?)<\/p>/g)

// 匹配img标签 []
export const img = html => html.match(/<img [^>]*src=['"]([^'"]+)[^>]*>/g)

/**
 * 获取span标签文本
 * @param { string } html html标签
 * @return { Array<string> } span文本
 */
export function spansText(html) {
	return spans(html)?.map(item => {
		return spanText(item)
	})
}
/**
 * 替空打标点位
 * @param { string } html html标签
 * @return { string } html标签
 */
export function spansTextEmpty(html) {
	return html.replace(
		/<span (.*?)>(.*?)<\/span>/g,
		'<span style="padding: 0 0.5em;text-decoration: underline;color: #FF5E2A; display:inline">[@~]</span>'
	)
	// return html.replace(/<span (.*?)>(.*?)<\/span>/g, '<span>@|@|@</b>')
}
// 提取img标签的data属性（url）、type属性（文件格式）
export function filterImg(html) {
	let arr = []
	const imgLabel = html?.match(/<img [^>]*src=['"]([^'"]+)[^>]*>/g)
	imgLabel?.forEach(item => {
		let src, type
		item.replace(/<img [^>]*data=['"]([^'"]+)[^>]*>/g, (match, capture) => {
			src = capture
		})
		item.replace(/<img [^>]*type=['"]([^'"]+)[^>]*>/g, (match, capture) => {
			type = capture
		})
		arr.push({ src, type })
	})
	return arr
}
// 获取P标签文本，删除多余br标签
export function filterP(html) {
	let str = ''
	const pLabel = p(html)
	pLabel?.forEach(item => {
		str += item.replace(/<\/?p>/g, '')
	})
	str = str.replace(/<br>(.*?)/g, '')
	return str
}

/**
 * 数字转化字母
 * @param { number } num 0~26数字
 * @return { string } 大写英文字母
 */
export function numToColNo(num) {
	if (num < 0 || num > 26) {
		return ''
	}
	const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
	return letters.charAt(num)
}

/**
 * 数组元素填充字符串
 * @param { Array, string, string } array text ident
 * @return { string } 字符串
 */
export function itemRepString(array = ['world', 'world'], text = 'hello @ hello @', ident = '@') {
	let filterText = text
	array.forEach(item => {
		filterText = filterText.replace(ident, item)
	})
	return filterText
}

export function rand(min, max) {
	return Math.floor(Math.random() * (max - min)) + min
}
